$(document).ready(function () {
  var $fadeSections = $(".single-case_studies .page-wrapper").find("[data-animations*='fadeIn']");

  fadeOut($fadeSections);
});

function fadeIn($section) {
  $($section).find(".fade-in-animation").removeClass("section-faded-out");
}

function fadeOut($sections) {
  $sections.each(function() {
    $section = $(this);
    var topOfSection = $section.offset().top;
    var bottomOfWindow = $(window).scrollTop() + $(window).innerHeight();

    if (topOfSection >= bottomOfWindow) {
      $section.children().addClass("fade-in-animation section-faded-out");
    }
  });
}